import * as React from 'react';
export var useSearchParams = function () {
    var _a = React.useState([
        window.location.search,
        new URLSearchParams(window.location.search),
    ]), _b = _a[0], params = _b[1], setSearchParams = _a[1];
    var update = React.useCallback(function () {
        setSearchParams(function (state) {
            return state[0] === window.location.search
                ? state
                : [window.location.search, new URLSearchParams(window.location.search)];
        });
    }, []);
    React.useEffect(function () {
        var events = ['popstate', 'pushState', 'replaceState']; // Events pushState and replaceState are provided by wouter
        events.forEach(function (event) {
            window.addEventListener(event, update);
        });
        return function () {
            events.forEach(function (event) {
                window.removeEventListener(event, update);
            });
        };
    }, []);
    return params;
};
